<template>
  <div>
    <!-- GimnasiосView -->
  </div>
</template>

<script>
export default {
  name: 'GimnasiосView'
}
</script>



// WEBPACK FOOTER //
// src/views/admin/GimnasiosView.vue